module.exports = __webpack_public_path__ + "img/jiangzhaung.27f5209e.png";